import React, { useState, useEffect } from "react";
import ProjectCard from "../../components/ProjectCards/index";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Box, Typography } from "@material-ui/core";

import style from "./style";
const useStyles = makeStyles(style);

const ProjectsPage = ({ projects }) => {
  const classes = useStyles();
  const [setIsDesktop] = useState(window.innerWidth > 900);
  const updateMedia = () => {
    setIsDesktop(window.innerWidth > 900);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });
  return (
    <div className="page">
      <Typography data-aos="fade-in" variant="h2" className={classes.title}>
        Selected Projects
      </Typography>
      <Typography data-aos="fade-in" data-aos-delay="100" variant="h6" gutterBottom className={classes.description}>
        Here’s some of my projects which showcases my skills in the field of development and UI/UX design.
      </Typography>
      <Grid className={classes.projectGrid}>
        <Box className={classes.cardSection}>
          <ProjectCard data-aos="fade-in" data-aos-delay="200" data={projects} />
        </Box>
      </Grid>
    </div>
  );
};

export default ProjectsPage;
